var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-210 -326) translate(55 249) translate(0 .245) translate(155 77.755)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.58,
    cy: 14.58,
    r: 14.58,
    fill: "#C871E3"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.109 0h-9.72C.625 0 0 .625 0 1.389v9.72c0 .763.625 1.388 1.389 1.388h9.72c.763 0 1.388-.625 1.388-1.388v-9.72C12.497.625 11.872 0 11.11 0zM4.166 9.72H2.777V4.86h1.389v4.86zm2.777 0H5.554V2.777h1.389V9.72zm2.777 0H8.331V6.943H9.72V9.72z",
    transform: "translate(8.331 8.331)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyMessage);
export default __webpack_public_path__ + "static/media/SurveyMessage.6340b0da665423addfc75aff2e13a928.svg";
export { ForwardRef as ReactComponent };